import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import actions from "../actions/alertsListActions";
import { fetchAlerts, getAlertsCount } from "../apis";
export var fetchAlertsListAction = function fetchAlertsListAction(pageToken, sortBy, sortOrder, filters) {
  return {
    type: actions.fetchAlertsList,
    requestParam: {
      pageToken: pageToken,
      sortBy: sortBy,
      sortOrder: sortOrder,
      filters: encodeURIComponent(_JSON$stringify(filters))
    },
    payload: {
      isLoading: true
    }
  };
};
export var fetchAlertsList = function fetchAlertsList(pageToken, sortBy, sortOrder, filters, alertsApiBaseUrl, apipathprefix, accessTokenApiPath) {
  return function (dispatch) {
    dispatch(fetchAlertsListAction(pageToken, sortBy, sortOrder, filters));
    return _Promise.all([fetchAlerts({
      apiBaseUrl: alertsApiBaseUrl,
      pathprefix: apipathprefix,
      accessTokenApiPath: accessTokenApiPath,
      payload: {
        pageToken: pageToken,
        sortBy: sortBy,
        sortOrder: sortOrder,
        filters: encodeURIComponent(_JSON$stringify(filters))
      }
    }), getAlertsCount({
      apiBaseUrl: alertsApiBaseUrl,
      pathprefix: apipathprefix,
      accessTokenApiPath: accessTokenApiPath
    })]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          alertsResponse = _ref2[0],
          count = _ref2[1].count;

      dispatch(fetchAlertsListSucceeded(_objectSpread(_objectSpread({}, alertsResponse), {}, {
        alertsCount: count
      })));
    })["catch"](function (ex) {
      dispatch(fetchAlertsListFailed());
    });
  };
};
export var fetchAlertsListSucceeded = function fetchAlertsListSucceeded(_ref3) {
  var nextPageToken = _ref3.nextPageToken,
      alerts = _ref3.alerts,
      alertsCount = _ref3.alertsCount;
  return {
    type: actions.fetchingAlertsSucceeded,
    payload: {
      isLoading: false,
      isFirstLoad: false,
      alerts: alerts || [],
      alertsCount: alertsCount,
      nextPageToken: nextPageToken
    }
  };
};
export var fetchAlertsListFailed = function fetchAlertsListFailed() {
  return {
    type: actions.fetchingAlertsFailed,
    payload: {
      isFirstLoad: false,
      isLoading: false
    }
  };
};
export var loadMoreRowsAction = function loadMoreRowsAction(pageToken) {
  return {
    type: actions.loadMoreRows,
    requestParam: {
      pageToken: pageToken
    },
    payload: {
      loadingMore: true
    }
  };
};
export var loadMoreRows = function loadMoreRows(pageToken, alertsApiBaseUrl, apipathprefix, accessTokenApiPath) {
  return function (dispatch) {
    dispatch(loadMoreRowsAction(pageToken));
    return fetchAlerts({
      apiBaseUrl: alertsApiBaseUrl,
      pathprefix: apipathprefix,
      payload: {
        pageToken: pageToken
      },
      accessTokenApiPath: accessTokenApiPath
    }).then(function (response) {
      dispatch(loadMoreRowsSucceeded(response));
    })["catch"](function (ex) {
      dispatch(loadMoreRowsFailed());
    });
  };
};
export var loadMoreRowsSucceeded = function loadMoreRowsSucceeded(_ref4) {
  var nextPageToken = _ref4.nextPageToken,
      alerts = _ref4.alerts;
  return {
    type: actions.loadMoreRowsSucceeded,
    payload: {
      loadingMore: false,
      alerts: alerts || [],
      nextPageToken: nextPageToken
    }
  };
};
export var loadMoreRowsFailed = function loadMoreRowsFailed() {
  return {
    type: actions.loadMoreRowsFailed,
    payload: {
      loadingMore: false
    }
  };
};
export var setTableOrder = function setTableOrder(sortBy, sortOrder) {
  return {
    type: actions.setTableOrder,
    payload: {
      nextPageToken: "",
      isFirstLoad: true,
      sortBy: sortBy,
      sortOrder: sortOrder
    }
  };
};
export var setFilters = function setFilters(filters) {
  return {
    type: actions.setFilters,
    payload: {
      nextPageToken: "",
      isFirstLoad: true,
      filters: filters
    }
  };
};